export const isSomeEnum =
  <Enum extends object>(someEnum: Enum) =>
  (keyOfEnum: unknown): keyOfEnum is Enum[keyof Enum] =>
    Object.values(someEnum).includes(keyOfEnum)

export const isNonNullable = <T>(val?: T | null | undefined): val is T => val !== null && typeof val !== 'undefined'
